import React, { useState } from 'react';
import api from '../utils/api';

const types = [
    { id: 'reclamation', icon: '🔴', label: 'Réclamation', desc: 'Signaler un problème', color: '#ef4444' },
    { id: 'suggestion', icon: '💡', label: 'Suggestion', desc: 'Proposer une amélioration', color: '#00d4ff' },
    { id: 'satisfaction', icon: '⭐', label: 'Satisfaction', desc: 'Partager un retour positif', color: '#10b981' },
];

const canaux = [
    { id: 'oral', icon: '🗣️', label: 'Oral' },
    { id: 'appel', icon: '📞', label: 'Appel' },
    { id: 'mail', icon: '📧', label: 'Mail' },
    { id: 'message', icon: '💬', label: 'Message' },
];

const Stars = () => (
    <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
        {Array.from({ length: 80 }, (_, i) => (
            <div key={i} style={{
                position: 'absolute',
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                background: 'white', borderRadius: '50%',
                left: Math.random() * 100 + '%',
                top: Math.random() * 100 + '%',
                opacity: Math.random() * 0.7 + 0.1,
                animation: `twinkle ${Math.random() * 3 + 2}s ease-in-out infinite`,
                animationDelay: Math.random() * 3 + 's'
            }} />
        ))}
        <style>{`@keyframes twinkle{0%,100%{opacity:0.1}50%{opacity:0.8}}`}</style>
    </div>
);

const PublicFormPage = () => {
    const [typeMessage, setTypeMessage] = useState('');
    const [origineCanal, setOrigineCanal] = useState('');
    const [form, setForm] = useState({ nom: '', prenom: '', email: '', telephone: '', objet: '', message: '', consentement: false });
    const [fichier, setFichier] = useState(null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [reference, setReference] = useState('');

    const update = field => e => setForm(f => ({ ...f, [field]: e.target.value }));

    const validate = () => {
        const errs = {};
        if (!typeMessage) errs.type = 'Choisissez un type';
        if (!origineCanal) errs.canal = 'Choisissez un canal';
        if (!form.prenom.trim()) errs.prenom = 'Prénom requis';
        if (!form.nom.trim()) errs.nom = 'Nom requis';
        if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) errs.email = 'Email invalide';
        if (!form.objet.trim()) errs.objet = 'Objet requis';
        if (form.message.trim().length < 10) errs.message = 'Message trop court';
        if (!form.consentement) errs.consentement = 'Consentement obligatoire';
        return errs;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errs = validate();
        setErrors(errs);
        if (Object.keys(errs).length > 0) return;
        setLoading(true);
        try {
            const formData = new FormData();
            Object.entries(form).forEach(([k, v]) => formData.append(k, v.toString()));
            formData.append('type_message', typeMessage);
            formData.append('origine_canal', origineCanal);
            if (fichier) formData.append('fichier', fichier);
            const { data } = await api.post('/messages', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            setReference(data.reference);
            setSuccess(true);
        } catch (err) {
            setErrors({ submit: err.response?.data?.message || 'Erreur lors de l\'envoi' });
        }
        setLoading(false);
    };

    const reset = () => {
        setSuccess(false);
        setForm({ nom: '', prenom: '', email: '', telephone: '', objet: '', message: '', consentement: false });
        setTypeMessage('');
        setOrigineCanal('');
        setFichier(null);
        setErrors({});
    };

    const inputStyle = {
        width: '100%', padding: '12px 16px',
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(0,212,255,0.2)',
        borderRadius: 10, fontSize: 14,
        color: 'white', fontFamily: 'inherit', outline: 'none',
        transition: 'all 0.2s', boxSizing: 'border-box'
    };

    const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.7)', marginBottom: 7 };

    if (success) return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#0a1628 0%,#0f2744 50%,#0a1628 100%)', display: 'flex', flexDirection: 'column', position: 'relative' }}>
            <Stars />
            <header style={{ background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(0,212,255,0.15)', padding: '0 40px', height: 70, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div style={{ width: 44, height: 44, background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 900, color: 'white', boxShadow: '0 0 20px rgba(0,212,255,0.3)' }}>CS</div>
                    <div><div style={{ fontSize: 17, fontWeight: 800, color: 'white' }}>CS FORM</div><div style={{ fontSize: 11, color: 'rgba(0,212,255,0.7)', textTransform: 'uppercase', letterSpacing: 1 }}>École de Commerce, du Numérique et de l'Industrie</div></div>
                </div>
            </header>
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative', zIndex: 1 }}>
                <div style={{ background: 'rgba(255,255,255,0.04)', backdropFilter: 'blur(20px)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: 24, padding: '60px 48px', maxWidth: 520, width: '100%', textAlign: 'center', boxShadow: '0 25px 60px rgba(0,0,0,0.4)' }}>
                    <div style={{ width: 80, height: 80, background: 'linear-gradient(135deg,#10b981,#059669)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, margin: '0 auto 24px', boxShadow: '0 0 30px rgba(16,185,129,0.4)' }}>✅</div>
                    <h2 style={{ fontSize: 28, fontWeight: 800, color: 'white', marginBottom: 12 }}>Message bien reçu !</h2>
                    <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, marginBottom: 20 }}>Notre équipe va examiner votre message et vous répondra dans les meilleurs délais.</p>
                    <div style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', borderRadius: 12, padding: '14px 24px', display: 'inline-block', fontFamily: 'monospace', fontSize: 22, fontWeight: 700, color: '#00d4ff', letterSpacing: 2, marginBottom: 8, boxShadow: '0 0 20px rgba(0,212,255,0.2)' }}>{reference}</div>
                    <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginBottom: 8 }}>Conservez cette référence pour le suivi</p>
                    <div style={{ background: 'rgba(30,111,224,0.15)', border: '1px solid rgba(30,111,224,0.3)', borderRadius: 8, padding: '10px 16px', fontSize: 13, color: '#60a5fa', marginBottom: 24 }}>⏱️ Délai de traitement : <strong>72 heures ouvrables</strong></div>
                    <button onClick={reset} style={{ background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', border: 'none', borderRadius: 12, padding: '13px 32px', fontSize: 15, fontWeight: 700, color: 'white', cursor: 'pointer', boxShadow: '0 0 20px rgba(0,212,255,0.3)' }}>✉️ Nouveau message</button>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg,#0a1628 0%,#0f2744 50%,#0a1628 100%)', position: 'relative' }}>
            <Stars />
            <header style={{ background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(0,212,255,0.15)', padding: '0 40px', height: 70, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div style={{ width: 44, height: 44, background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 900, color: 'white', boxShadow: '0 0 20px rgba(0,212,255,0.3)' }}>CS</div>
                    <div><div style={{ fontSize: 17, fontWeight: 800, color: 'white' }}>CS FORM</div><div style={{ fontSize: 11, color: 'rgba(0,212,255,0.7)', textTransform: 'uppercase', letterSpacing: 1 }}>École de Commerce, du Numérique et de l'Industrie</div></div>
                </div>
                <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>Réponse sous <strong style={{ color: '#00d4ff' }}>72h</strong></div>
            </header>

            <div style={{ maxWidth: 720, margin: '0 auto', padding: '50px 24px', position: 'relative', zIndex: 1 }}>
                <div style={{ textAlign: 'center', marginBottom: 48 }}>
                    <div style={{ display: 'inline-block', background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', borderRadius: 30, padding: '6px 18px', fontSize: 12, color: '#00d4ff', marginBottom: 16, letterSpacing: 1, textTransform: 'uppercase' }}>Portail de satisfaction</div>
                    <h2 style={{ fontSize: 36, fontWeight: 800, color: 'white', lineHeight: 1.2, marginBottom: 14 }}>Votre avis <span style={{ color: '#00d4ff' }}>nous importe</span></h2>
                    <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.5)', lineHeight: 1.7, maxWidth: 480, margin: '0 auto' }}>Réclamation, suggestion ou satisfaction — partagez votre expérience avec CS FORM.</p>
                </div>

                <div style={{ background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(20px)', border: '1px solid rgba(0,212,255,0.15)', borderRadius: 24, padding: 40, boxShadow: '0 25px 60px rgba(0,0,0,0.3)' }}>
                    <form onSubmit={handleSubmit} noValidate>

                        {/* Type de message */}
                        <div style={{ marginBottom: 28 }}>
                            <div style={labelStyle}>Type de message <span style={{ color: '#ef4444' }}>*</span></div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12 }}>
                                {types.map(t => (
                                    <div key={t.id} onClick={() => { setTypeMessage(t.id); setErrors(e => ({ ...e, type: '' })) }} style={{
                                        border: `2px solid ${typeMessage === t.id ? t.color : 'rgba(255,255,255,0.1)'}`,
                                        borderRadius: 12, padding: 16, cursor: 'pointer', textAlign: 'center',
                                        background: typeMessage === t.id ? `rgba(${t.id === 'reclamation' ? '239,68,68' : t.id === 'suggestion' ? '0,212,255' : '16,185,129'},0.1)` : 'rgba(255,255,255,0.03)',
                                        transition: 'all 0.2s',
                                        boxShadow: typeMessage === t.id ? `0 0 20px rgba(${t.id === 'reclamation' ? '239,68,68' : t.id === 'suggestion' ? '0,212,255' : '16,185,129'},0.2)` : 'none'
                                    }}>
                                        <span style={{ fontSize: 28, display: 'block', marginBottom: 8 }}>{t.icon}</span>
                                        <span style={{ fontSize: 13, fontWeight: 700, color: 'white', display: 'block' }}>{t.label}</span>
                                        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', display: 'block', marginTop: 3 }}>{t.desc}</span>
                                    </div>
                                ))}
                            </div>
                            {errors.type && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 6 }}>⚠️ {errors.type}</div>}
                        </div>

                        {/* Origine / Canal */}
                        <div style={{ marginBottom: 28 }}>
                            <div style={labelStyle}>Origine / Canal <span style={{ color: '#ef4444' }}>*</span></div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10 }}>
                                {canaux.map(c => (
                                    <div key={c.id} onClick={() => { setOrigineCanal(c.id); setErrors(e => ({ ...e, canal: '' })) }} style={{
                                        border: `2px solid ${origineCanal === c.id ? '#00d4ff' : 'rgba(255,255,255,0.1)'}`,
                                        borderRadius: 10, padding: '12px 8px', cursor: 'pointer', textAlign: 'center',
                                        background: origineCanal === c.id ? 'rgba(0,212,255,0.1)' : 'rgba(255,255,255,0.03)',
                                        transition: 'all 0.2s',
                                        boxShadow: origineCanal === c.id ? '0 0 15px rgba(0,212,255,0.2)' : 'none'
                                    }}>
                                        <span style={{ fontSize: 22, display: 'block', marginBottom: 6 }}>{c.icon}</span>
                                        <span style={{ fontSize: 12, fontWeight: 700, color: 'white' }}>{c.label}</span>
                                    </div>
                                ))}
                            </div>
                            {errors.canal && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 6 }}>⚠️ {errors.canal}</div>}
                        </div>

                        {/* Prénom / Nom */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                            <div style={{ marginBottom: 20 }}>
                                <label style={labelStyle}>Prénom <span style={{ color: '#ef4444' }}>*</span></label>
                                <input type="text" style={{ ...inputStyle, borderColor: errors.prenom ? '#ef4444' : 'rgba(0,212,255,0.2)' }} value={form.prenom} onChange={update('prenom')} placeholder="Votre prénom" />
                                {errors.prenom && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>{errors.prenom}</div>}
                            </div>
                            <div style={{ marginBottom: 20 }}>
                                <label style={labelStyle}>Nom <span style={{ color: '#ef4444' }}>*</span></label>
                                <input type="text" style={{ ...inputStyle, borderColor: errors.nom ? '#ef4444' : 'rgba(0,212,255,0.2)' }} value={form.nom} onChange={update('nom')} placeholder="Votre nom" />
                                {errors.nom && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>{errors.nom}</div>}
                            </div>
                        </div>

                        {/* Email / Téléphone */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                            <div style={{ marginBottom: 20 }}>
                                <label style={labelStyle}>Email <span style={{ color: '#ef4444' }}>*</span></label>
                                <input type="email" style={{ ...inputStyle, borderColor: errors.email ? '#ef4444' : 'rgba(0,212,255,0.2)' }} value={form.email} onChange={update('email')} placeholder="votre@email.com" />
                                {errors.email && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>{errors.email}</div>}
                            </div>
                            <div style={{ marginBottom: 20 }}>
                                <label style={labelStyle}>Téléphone</label>
                                <input type="tel" style={inputStyle} value={form.telephone} onChange={update('telephone')} placeholder="+229 97 XX XX XX" />
                            </div>
                        </div>

                        {/* Objet */}
                        <div style={{ marginBottom: 20 }}>
                            <label style={labelStyle}>Objet <span style={{ color: '#ef4444' }}>*</span></label>
                            <input type="text" style={{ ...inputStyle, borderColor: errors.objet ? '#ef4444' : 'rgba(0,212,255,0.2)' }} value={form.objet} onChange={update('objet')} placeholder="Résumez en quelques mots" />
                            {errors.objet && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>{errors.objet}</div>}
                        </div>

                        {/* Message */}
                        <div style={{ marginBottom: 20 }}>
                            <label style={labelStyle}>Message <span style={{ color: '#ef4444' }}>*</span></label>
                            <textarea style={{ ...inputStyle, borderColor: errors.message ? '#ef4444' : 'rgba(0,212,255,0.2)', resize: 'vertical', minHeight: 120 }} value={form.message} onChange={update('message')} placeholder="Décrivez votre demande en détail..."></textarea>
                            {errors.message && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 4 }}>{errors.message}</div>}
                        </div>

                        {/* Pièce jointe */}
                        <div style={{ marginBottom: 20 }}>
                            <label style={labelStyle}>Pièce jointe (optionnel)</label>
                            <div style={{ border: '2px dashed rgba(0,212,255,0.2)', borderRadius: 12, padding: 24, textAlign: 'center', cursor: 'pointer', position: 'relative', background: 'rgba(0,212,255,0.03)', transition: 'all 0.2s' }}>
                                <input type="file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" onChange={e => setFichier(e.target.files[0])} style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer' }} />
                                {fichier ? (
                                    <div><div style={{ fontSize: 24, marginBottom: 6 }}>📎</div><div style={{ fontWeight: 600, color: '#00d4ff' }}>{fichier.name}</div></div>
                                ) : (
                                    <div><div style={{ fontSize: 24, marginBottom: 6 }}>📂</div><div style={{ fontWeight: 600, fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>Cliquez pour joindre un fichier</div><div style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)', marginTop: 3 }}>JPG, PNG, PDF, DOC — Max 5MB</div></div>
                                )}
                            </div>
                        </div>

                        {/* Consentement */}
                        <div style={{ marginBottom: 24 }}>
                            <div onClick={() => setForm(f => ({ ...f, consentement: !f.consentement }))} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: 16, background: 'rgba(255,255,255,0.03)', border: `1px solid ${errors.consentement ? '#ef4444' : 'rgba(255,255,255,0.08)'}`, borderRadius: 10, cursor: 'pointer' }}>
                                <input type="checkbox" checked={form.consentement} onChange={() => { }} style={{ width: 18, height: 18, flexShrink: 0, marginTop: 2, accentColor: '#00d4ff' }} />
                                <label style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6, cursor: 'pointer' }}>J'accepte que mes données soient utilisées pour le traitement de ma demande par CS FORM.</label>
                            </div>
                            {errors.consentement && <div style={{ fontSize: 12, color: '#ef4444', marginTop: 6 }}>⚠️ {errors.consentement}</div>}
                        </div>

                        {errors.submit && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13, color: '#fca5a5' }}>⚠️ {errors.submit}</div>}

                        <button type="submit" disabled={loading} style={{ width: '100%', background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', border: 'none', borderRadius: 12, padding: '15px 28px', fontSize: 16, fontWeight: 700, color: 'white', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, boxShadow: '0 0 30px rgba(0,212,255,0.3)', transition: 'all 0.2s' }}>
                            {loading ? '⏳ Envoi en cours...' : '📩 Envoyer mon message'}
                        </button>
                    </form>
                </div>

                <div style={{ textAlign: 'center', marginTop: 32, fontSize: 13, color: 'rgba(255,255,255,0.25)' }}>
                    © {new Date().getFullYear()} CS FORM — École de Commerce, du Numérique et de l'Industrie
                </div>
            </div>
        </div>
    );
};

export default PublicFormPage;